export const SIDEBAR_KEY_STORAGE = {
  EXPANDED_ITEMS: "EXPANDED_ITEMS",
  SELECTED_ITEM: "SELECTED_ITEM",
} as const;
